import { render, staticRenderFns } from "./CareTeam.vue?vue&type=template&id=a9dc5190&scoped=true"
import script from "./CareTeam.vue?vue&type=script&lang=js"
export * from "./CareTeam.vue?vue&type=script&lang=js"
import style0 from "./CareTeam.vue?vue&type=style&index=0&id=a9dc5190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dc5190",
  null
  
)

export default component.exports